import { combineReducers } from "redux";
import { arrayToObject } from "../../utils/arrayToObject";
import { getFailureActionType, getSuccessActionType } from "../utils";
import {
  CHANGE_INSURANCE_STATUS_REQUEST,
  CHANGE_INSURANCE_WEIGHT_REQUEST,
  CREATE_INSURANCE_REQUEST,
  FETCH_INSURANCES_REQUEST,
  UPDATE_INSURANCE_REQUEST,
} from "./constants";
import { Action, InsurancesState } from "./types";

function items(state: InsurancesState = {}, action: Action): InsurancesState {
  switch (action.type) {
    case getSuccessActionType(FETCH_INSURANCES_REQUEST):
      return arrayToObject(action.payload);

    case getSuccessActionType(CREATE_INSURANCE_REQUEST):
      return { ...state, [action.data.insuranceId]: { isFetching: true, ...state[action.data.insuranceId] } };

    case UPDATE_INSURANCE_REQUEST:
    case CHANGE_INSURANCE_STATUS_REQUEST:
    case CHANGE_INSURANCE_WEIGHT_REQUEST:
      return { ...state, [action.data.insuranceId]: { isFetching: true, ...state[action.data.insuranceId] } };

    case getSuccessActionType(UPDATE_INSURANCE_REQUEST):
    case getSuccessActionType(CHANGE_INSURANCE_STATUS_REQUEST):
    case getSuccessActionType(CHANGE_INSURANCE_WEIGHT_REQUEST):
      return { ...state, [action.data.insuranceId]: { isFetching: false, ...action.payload } };

    case getFailureActionType(UPDATE_INSURANCE_REQUEST):
    case getFailureActionType(CHANGE_INSURANCE_STATUS_REQUEST):
    case getFailureActionType(CHANGE_INSURANCE_WEIGHT_REQUEST):
      return {
        ...state,
        [action.data.insuranceId]: { isFetching: false, ...state[action.data.insuranceId] },
      };

    default:
      return state;
  }
}

function isFetching(state = false, action: Action) {
  switch (action.type) {
    case FETCH_INSURANCES_REQUEST:
      return true;
    case getSuccessActionType(FETCH_INSURANCES_REQUEST):
    case getFailureActionType(FETCH_INSURANCES_REQUEST):
      return false;

    default:
      return state;
  }
}

export const insurances = combineReducers({ items, isFetching });
